const environment = import.meta.env.VITE_CURRENT_PUBLIC_SERVER_TAG_TYPE;
const appVersion = import.meta.env.VERSION;
const version = appVersion;
const buildVersion = appVersion;

console.log('LoginBuildVersion:::', buildVersion);

export default {
    version,
    buildVersion,
    requestPath: environment === 'local' ? 'https://www.smartvideomaker.com' : '',
    // languagePath: environment === 'local' ? `${basePath}language/local.` : `${basePath}media/login_panel/v1/language/local.`,
    languagePath: environment === 'local' ? `language/local.` : `/app/login/login-panel/language/local.`,
    serverPath: environment === 'release' ? 'https://www.flexclip.com' : 'https://www.smartvideomaker.com',
};
